import {validApplicationTypeGuard} from './abstract-application.guard';

export const validInsurancePremiumGuard = () => {
  return validApplicationTypeGuard('InsurancePremium', 'e-not-insurance');
}
